<template>
  <div class="results-header">
    <p class="results-header__title">
      Знайдено:
      <span
        v-if="isLoading"
        class="results-header__skeleton"
      ></span>
      <span
        v-else
        class="results-header__count"
      >
        {{ found }}
      </span>
    </p>

    <div class="results-header__toolbar">
      <div class="results-header__toolbar__actions">
        <button
          v-if="!showEarnings"
          class="results-header__btn results-header__btn--earnings"
          :disabled="isLoading"
          @click="$emit('changeShowEarnings', !showEarnings)"
        >
          <EyeOpenIcon class="results-header__icon" />
          Показати заробіток
        </button>

        <button
          v-if="showEarnings"
          class="results-header__btn results-header__btn--earnings"
          :disabled="isLoading"
          @click="$emit('changeShowEarnings', !showEarnings)"
        >
          <EyeHideIcon class="results-header__icon" />
          Сховати заробіток
        </button>
      </div>
      <div
        v-if="sortByMenuItems.length > 0 || viewModeMenuItems.length > 0"
        class="results-header__toolbar__actions"
      >
        <MenuList
          v-if="sortByMenuItems.length > 0"
          ref="sortByMenu"
          class="results-header__btn results-header__btn--sort"
          :disable="isLoading"
          :items="sortByMenuItems"
          :selected-item="selectedSortBy"
          :checkbox-style="checkboxStyle"
          :hide-icon="true"
        >
          <SortIcon
            class="results-header__icon"
            :color="getSortByIconColor"
          />
          Сортування
        </MenuList>

        <MenuList
          v-if="viewModeMenuItems.length > 0"
          class="results-header__btn results-header__btn--view"
          :disable="isLoading"
          :items="viewModeMenuItems"
          :selected-item="selectedViewMode"
          :checkbox-style="checkboxStyle"
          :hide-icon="true"
          :highlight-active="false"
        >
          <ViewIcon
            class="results-header__icon"
            :color="isLoading ? '#6b7280' : '#09090B'"
          />
          Вид
        </MenuList>
      </div>
    </div>
  </div>
</template>

<script>
import MenuList from './menu-list';
import { EyeHideIcon, EyeOpenIcon, SortIcon, ViewIcon } from '@/shared/ui/icons';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    found: {
      type: Number,
      default: 0,
    },
    showEarnings: {
      type: Boolean,
      default: false,
    },
    sortByMenuItems: {
      type: Array,
      default: () => [],
    },
    selectedSortBy: {
      type: Object,
      default: () => {},
    },
    viewModeMenuItems: {
      type: Array,
      default: () => [],
    },
    selectedViewMode: {
      type: Object,
      default: () => {},
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
  },
  components: { EyeOpenIcon, EyeHideIcon, SortIcon, ViewIcon, MenuList },
  computed: {
    getSortByIconColor() {
      if (this.isLoading) {
        return '#6b7280';
      }

      if (this.$refs.sortByMenu?.hasActiveFilters) {
        return '#fb923c';
      }

      return '#09090B';
    },
  },
};
</script>

<style lang="scss" scoped>
.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.06), 0 1px 3px 0 rgb(0 0 0 / 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }

  &__title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    color: #09090b;
    margin: 0;
  }

  &__count {
    margin-left: 6px;
  }

  &__skeleton {
    display: inline-block;
    width: 30px;
    height: 24px;
    border-radius: 4px;
    background: linear-gradient(90deg, #f1efef -24.18%, #f9f8f8 50.26%, #e7e5e5 114.84%);
    background-size: 200% 100%;
    margin-left: 10px;
    animation: shimmer 1.4s infinite;
  }

  &__toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
      width: 100%;
      flex-wrap: wrap;
    }

    @media (max-width: 550px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 0;
      padding: 4px 0;
    }

    &__actions {
      display: flex;
    }
  }

  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    color: #09090b;
    outline: none;
    background: transparent;
    cursor: pointer;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    @media (max-width: 1200px) {
      padding: 0 8px;
    }

    @media (max-width: 550px) {
      padding: 0;
    }

    &--sort {
      @media (max-width: 550px) {
        margin-left: -12px;
      }
    }
  }

  &__icon {
    margin-right: 8px;
    flex-shrink: 0;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

::v-deep .menu-dropdown__trigger:hover:not(.menu-dropdown__trigger--disabled) {
  background: transparent;
}

::v-deep .menu-dropdown__trigger--disabled {
  background: transparent;
}

::v-deep .menu-list {
  box-shadow: none !important;
}
</style>
